import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackModel } from './rack.model';


export class RackAckResponse extends GlobalResponseObject{
    data?: RackModel[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RackModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 